import { render, staticRenderFns } from "./ActivationList.vue?vue&type=template&id=2521964e&"
import script from "./ActivationList.vue?vue&type=script&lang=ts&"
export * from "./ActivationList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationList.vue?vue&type=style&index=0&id=2521964e&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports